// Footer compartilhado (landing + pricing) — mantém o header/rodapé idênticos
// entre as páginas públicas.
import { Link } from 'react-router-dom';
import { Moon } from 'lucide-react';

const socials = [
  {
    name: 'X',
    href: 'https://x.com',
    path: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  },
  {
    name: 'Instagram',
    href: 'https://instagram.com',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z',
  },
  {
    name: 'Telegram',
    href: 'https://telegram.org',
    path: 'M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z',
  },
  {
    name: 'Discord',
    href: 'https://discord.com',
    path: 'M20.317 4.369a19.79 19.79 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z',
  },
];

export function LandingFooter() {
  return (
    <footer className="relative overflow-hidden border-t border-border bg-card pt-16 pb-10">
      {/* Moonlit footer background — cover, anchored to bottom-center, not stretched */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        {/* Vertical art on mobile, wide art on larger screens */}
        <img
          src="/footer-bg-vertical.webp"
          alt=""
          className="h-full w-full object-cover object-bottom opacity-40 dark:opacity-80 sm:hidden"
        />
        <img
          src="/footer-bg.webp"
          alt=""
          className="hidden h-full w-full object-cover object-bottom opacity-40 dark:opacity-80 sm:block"
        />
        {/* Theme-aware overlay: solid at top for legible links, reveals the horizon below */}
        <div className="absolute inset-0 bg-gradient-to-b from-card via-card/75 to-card/45 dark:from-card/75 dark:via-card/45 dark:to-card/25" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 lg:col-span-2">
            <a
              href="/"
              className="flex items-center gap-2 font-serif text-2xl font-bold tracking-tight mb-4 text-primary"
            >
              <img src="/log-black.png" alt="" aria-hidden="true" className="h-8 w-8 object-contain dark:hidden" />
              <img src="/log-white.png" alt="" aria-hidden="true" className="hidden h-8 w-8 object-contain dark:block" />
              <span>reformu<span className="text-accent">.</span>lat</span>
            </a>
            <p className="text-sm max-w-xs mb-6 text-muted-foreground">
              Connecting authors with the world's best publishing professionals.
            </p>
            <div className="flex flex-wrap gap-3">
              {socials.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="w-9 h-9 rounded-full flex items-center justify-center transition-colors bg-foreground/5 text-muted-foreground hover:bg-primary/10 hover:text-primary"
                >
                  <span className="sr-only">{s.name}</span>
                  <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                    <path d={s.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground/70">
              For Authors
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/#services" className="text-muted-foreground transition-colors hover:text-foreground">
                  Find a Professional
                </a>
              </li>
              <li>
                <a href="/#how-it-works" className="text-muted-foreground transition-colors hover:text-foreground">
                  How it Works
                </a>
              </li>
              <li>
                <a href="/pricing" className="text-muted-foreground transition-colors hover:text-foreground">
                  Pricing
                </a>
              </li>
              <li>
                <Link to="/author-trust" className="text-muted-foreground transition-colors hover:text-foreground">
                  Author Trust
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground/70">
              For Professionals
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/join-professional" className="text-muted-foreground transition-colors hover:text-foreground">
                  Join as a Professional
                </Link>
              </li>
              <li>
                <Link to="/freelancer-success" className="text-muted-foreground transition-colors hover:text-foreground">
                  Freelancer Success
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-muted-foreground transition-colors hover:text-foreground">
                  Community
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground/70">
              Company
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/about" className="text-muted-foreground transition-colors hover:text-foreground">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground transition-colors hover:text-foreground">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-muted-foreground transition-colors hover:text-foreground">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground transition-colors hover:text-foreground">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-4 flex flex-col gap-4 border-t border-border pt-8 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} reformu.lat · Feito sob a luz da lua <Moon className="inline h-3.5 w-3.5" />
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs">
            <Link to="/privacidade" className="text-muted-foreground transition-colors hover:text-foreground">
              Política de Privacidade
            </Link>
            <Link to="/termos" className="text-muted-foreground transition-colors hover:text-foreground">
              Termos de Uso
            </Link>
            <Link to="/status" className="text-muted-foreground transition-colors hover:text-foreground">
              Status
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
